<template>
    <div class="moneysuccess">
        支付成功
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// moneySuccess.vue?7155fc20